export function capitalize(string: undefined): undefined;
export function capitalize(string: string): string;
export function capitalize(string: string | undefined): string | undefined {
  if (!string) return undefined;
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function titleCase(string: undefined): undefined;
export function titleCase(string: string): string;
export function titleCase(string: string | undefined): string | undefined {
  if (!string) return undefined;

  return string.toLowerCase().replace(/\S+/g, (word) => {
    return capitalize(word);
  });
}

export function snakeCase(string: undefined): undefined;
export function snakeCase(string: string): string;
export function snakeCase(string: string | undefined): string | undefined {
  if (!string) return undefined;

  return string
    .trim()
    .toLowerCase()
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    ?.join("_");
}

export function stringPresent(
  content: string | null | undefined
): content is string {
  if (content == null || content == undefined) return false;
  return content.trim() != "";
}

export function fixhyphens(text: string): string {
  return text.replace(/(\S+)-(\S+)/g, "$1&#8288;-&#8288;$2");
}

export const NON_BREAKING_SPACE = "\u00a0";

// use unicode non breaking space to prevent the port name to be splitted in multiple rows
export const nonBreakingSpaceString = (name: string) =>
  name.replace(/ /g, NON_BREAKING_SPACE);

export const splitCodesStringList = (list: string): string[] => {
  return (
    list
      .toUpperCase()
      .split(/[\r?\n,]+/)
      .map((c) => c.trim())
      .filter((c) => c && c != "") || []
  );
};
